import React from "react"
import ControlButtonStandard, {ControlButtonType} from "../../../../gd-components/buttons/control-button/control-button-standard"
import FieldCopyContent_ActionClick from "../actions/copy-click"
import FieldProto from "../../../proto/field-proto"

type Props = {
    field: FieldProto
    value: string
}

const debug = false
// const debug = "FieldCopyContentButton"

export default function FieldCopyContentButton(props:Props) {

    debug && console.log(debug, 'render', props)

    const onClick = (value:any) => {
        FieldCopyContent_ActionClick(props.field.label, props.value)
    }

    return <ControlButtonStandard className = "hover-bg"
                                  type      = {ControlButtonType.COPY}
                                  hint      = "Copy"
                                  onClick   = {onClick}/>

}